<small class="debug">{{me}}</small>
<app-header [showMenu]="true">
</app-header>
<div style="position: relative;">
  @if (showToggle) {
    <button class="hide-lt-sm toggle-button mini-button" matTooltip="{{'navigation.toggleVideoList' | transloco}}" mat-icon-button routerLink="/login">
      <mat-icon>keyboard_double_arrow_left</mat-icon>
    </button>
  }
  <div fxLayout="column wrap" fxLayoutAlign="center center" fxLayoutGap="16px">
    <mat-form-field class="form-element">
      <mat-label>total licenses</mat-label>
      <input inputrestriction="basic1" min="1" max="500" (keyup)="onPrice($event)" (change)="onPrice($event)" matInput type="number" name="SearchDualList" class="form-control" [(ngModel)]="modal" autocomplete="off"/>
      <a matSuffix aria-label="Clear" (click)="clearFilterSelection()">
        <mat-icon>close</mat-icon>
      </a>
    </mat-form-field>
    <br/>
    <mat-label class="prices">cost per screen: {{ licence | StringJSV2Pipe:stringJSPipeArgs }}</mat-label>
    <br/>
    <mat-label class="prices">total per month: {{ licences | StringJSV2Pipe:stringJSPipeArgs }}</mat-label>
    <mat-divider/>
    <div>
      <hr/>
      <p>total allowed max monthly cloud bandwidth in MB for a FREE user</p>
      <p>
        <mat-form-field class="form-element">
          <mat-label>megabytes</mat-label>
          <input inputrestriction="basic1" min="1" value="{{MAX_BANDWIDTH_MB}}" (keyup)="onMaxCloudBandwidth($event)" (change)="onMaxCloudBandwidth($event)"
            matInput type="number" name="SearchDualList" class="form-control" autocomplete="off"/>
          </mat-form-field>
        </p>
        <hr/>
        <p>total used storage of videos and images</p>
        <mat-form-field class="form-element">
          <mat-label>megabytes</mat-label>
          <input inputrestriction="basic1" min="1" matInput (keyup)="onUserStorage($event)" (change)="onUserStorage($event)"
            type="number" name="SearchDualList" class="form-control" [(ngModel)]="userStorage" autocomplete="off"/>
          </mat-form-field>
          <hr/>
          @if (exceed) {
            <span class="needToPayUser">
              NEED TO PAY
            </span>
          }
        </div>
      </div>

    </div>



